export enum UpgradeToProDialogType {
  UpgradeDialog = 'UPGRADE_DIALOG',
  TrialStartSuccessDialog = 'TRIAL_START_SUCCESS_DIALOG',
}
